module.exports = __webpack_public_path__ + "img/banner3_4_vi.71b42043.png";